// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__VQbxF","rootSmall":"AddTileButton_rootSmall__38UuS"};